import React from "react";
import { LightOptions } from "../../light/types";

const DEFAULT_SUPPLEMENT_BORD = 3;

interface LightOptionsFormProps {
  options: LightOptions;
  onChange: (next: LightOptions) => void;
}

export const LightOptionsForm: React.FC<LightOptionsFormProps> = ({ options, onChange }) => {
  const handleFondToggle = () => {
    const nextFond = !options.fond;
    onChange({
      ...options,
      fond: nextFond,
      grille: false,
      talonAgrafageActif: nextFond ? false : true,
      talonAgrafage: nextFond ? options.talonAgrafage : options.talonAgrafage ?? DEFAULT_SUPPLEMENT_BORD,
    });
  };

  const handleFermetureToggle = () => {
    onChange({ ...options, fermeture: !options.fermeture });
  };

  const handleSupplementToggle = () => {
    const nextActive = !(options.talonAgrafageActif ?? true);
    onChange({
      ...options,
      fond: options.fond ?? false,
      grille: false,
      talonAgrafageActif: options.fond ? false : nextActive,
      talonAgrafage: options.talonAgrafage ?? DEFAULT_SUPPLEMENT_BORD,
    });
  };

  const handleSupplementValue = (value: string) => {
    const num = Number(value);
    onChange({
      ...options,
      grille: false,
      talonAgrafage: Number.isFinite(num) ? num : options.talonAgrafage,
    });
  };

  const fondActif = !!options.fond;
  const supplementActif = !fondActif && (options.talonAgrafageActif ?? true);

  return (
    <div className="grid grid-cols-1 gap-3">
      <label className="flex items-start gap-3 rounded border border-gray-200 p-3 hover:border-gray-300 bg-white shadow-sm">
        <input
          type="checkbox"
          className="mt-1 rounded border-gray-300 focus:ring-blue-500 text-blue-600"
          checked={fondActif}
          onChange={handleFondToggle}
        />
        <div className="flex flex-col">
          <span className="font-medium text-gray-800">Fond</span>
          <span className="text-xs text-gray-500">Ajoute une pièce de fond (coussins/bâches)</span>
        </div>
      </label>

      <div className="flex flex-col gap-2 rounded border border-gray-200 p-3 hover:border-gray-300 bg-white shadow-sm">
        <label className="flex items-start gap-3">
          <input
            type="checkbox"
            className="mt-1 rounded border-gray-300 focus:ring-blue-500 text-blue-600"
            checked={supplementActif}
            disabled={fondActif}
            onChange={handleSupplementToggle}
          />
          <div className="flex flex-col">
            <span className={`font-medium ${fondActif ? "text-gray-400" : "text-gray-800"}`}>Supplément de bord</span>
            <span className="text-xs text-gray-500">
              Ajoute de la matière sur le bord ouvert pour une finition de type agrafage, ourlet ou fourreau.
            </span>
          </div>
        </label>
        <div className="flex items-center gap-2 pl-8">
          <input
            type="number"
            min={1}
            max={8}
            step={0.5}
            className="w-20 rounded border border-gray-300 px-2 py-1 text-sm focus:border-blue-500 focus:outline-none"
            value={options.talonAgrafage ?? DEFAULT_SUPPLEMENT_BORD}
            disabled={!supplementActif}
            onChange={(e) => handleSupplementValue(e.target.value)}
          />
          <span className="text-xs text-gray-500">cm</span>
        </div>
      </div>

      <label className="flex items-start gap-3 rounded border border-gray-200 p-3 hover:border-gray-300 bg-white shadow-sm">
        <input
          type="checkbox"
          className="mt-1 rounded border-gray-300 focus:ring-blue-500 text-blue-600"
          checked={!!options.fermeture}
          onChange={handleFermetureToggle}
        />
        <div className="flex flex-col w-full">
          <span className="font-medium text-gray-800">Fermeture</span>
          <span className="text-xs text-gray-500">Fermeture simple (éclair) incluse</span>
        </div>
      </label>
    </div>
  );
};

export default LightOptionsForm;
